import { useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigateLinks } from '@/components';
import { NotificationSeverity } from '@/components/notifications/Notification';
import useNotification from '@/hooks/useNotification';
import { getErrorMessage } from '@/utils/errorUtils';
import { TransitControlSearchBar, TransitControlTable } from './components';
import { childrenTransitControlPageBreadcrumbs } from './config/breadcrumbs';
import { useTransitControlFilter, useTransitControlPagination, useTransitControlList } from './hooks';

export const TransitControl = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenTransitControlPageBreadcrumbs(navigate),
    [navigate]
  );
  const { showNotification } = useNotification();

  const { filter, initialFilter, setFilter } = useTransitControlFilter();
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useTransitControlPagination();

  const {
    items,
    totalItems,
    totalPages,
    isTransitControlLoading,
    isTransitControlFetching,
    transitControlError,
  } = useTransitControlList({ page: currentPage, pageSize, filters: filter });

  const lastNotifiedError = useRef<unknown>(null);
  useEffect(() => {
    if (!transitControlError || transitControlError === lastNotifiedError.current) return;
    lastNotifiedError.current = transitControlError;
    const message = getErrorMessage(
      transitControlError,
      'No se pudo cargar el listado de Control de Tránsito.'
    );
    showNotification(message, NotificationSeverity.error);
  }, [transitControlError, showNotification]);

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks actualPage='Control de tránsito' breadcrumbs={breadcrumbs} />
      <TransitControlSearchBar
        initialFilter={initialFilter}
        filter={filter}
        isLoading={isTransitControlFetching}
        search={(updatedFilter) => {
          setFilter(updatedFilter);
          handlePageChange(1);
        }}
      />
      <TransitControlTable
        items={items}
        isLoading={isTransitControlLoading}
        totalItems={totalItems}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        dateTo={filter.dateTo}
      />
    </section>
  );
};

export default TransitControl;
